export default "__VITE_ASSET__CI4QU2LF__"